import { isStringDirty } from "@suse-o11y/is-string-dirty";
import { FormShape, FormUnit } from "@suse-o11y/signal/form";
import { z } from "zod";

export interface InitParams {
	name: string;
	description: string;
	starred: boolean;
	publiclyAccessible: boolean;
}

export function init({ name, description, starred, publiclyAccessible }: InitParams) {
	return FormShape({
		dashboard: FormShape({
			name: FormUnit(name, {
				schema: z.string().trim().min(1, "Dashboard name is required"),
				isInputDirty: isStringDirty,
			}),

			description: FormUnit(description, {
				isInputDirty: isStringDirty,
				schema: z.string().trim(),
			}),
		}),
		options: FormShape({
			starred: FormUnit(starred),
			publiclyAccessible: FormUnit(publiclyAccessible),
		}),
	});
}

export type FormState = ReturnType<typeof init>;
